import { createApp } from "vue";

import Main from "./App.vue";

createApp(Main).mount("#app");
